import React from "react";
import Grid from "@mui/material/Grid2";
import { SortAZ, SortZA } from "@assets/icons";
import { Add, CloudUploadOutlined, Refresh } from "@mui/icons-material";
import { MenuItemProps } from "@mui/material";
import { TFunction } from "react-i18next";
import { ControlsProps, SortDirections, SortObject } from "./types";
import Select from "./SelectField";
export const SelectField = Select;
import {
  DeleteButton,
  SortBySelect,
  TooltipButton,
  LabelContainer,
} from "./components";

export const getSortOptionsFn =
  <T extends string>(keys: T[]) =>
  (
    t: TFunction = (v: string) => v
  ): { label: React.ReactNode; value: SortObject<T> }[] =>
    keys
      .map((key) => [
        {
          label: (
            <LabelContainer>
              {t(key)} <SortAZ />
            </LabelContainer>
          ),
          value: { direction: SortDirections.ASC, key },
        },
        {
          label: (
            <LabelContainer>
              {t(key)} <SortZA />
            </LabelContainer>
          ),
          value: { direction: SortDirections.DESC, key },
        },
      ])
      .flat();

const Controls = <T extends MenuItemProps["value"]>(
  props: ControlsProps<T>
) => {
  const {
    onDelete,
    onAdd,
    onRefresh,
    onImport,
    deleteDisabled = false,
    canEdit = false,
    DeleteDialogProps,
    customAddTooltip,
    ...selectProps
  } = props;
  return (
    <Grid
      container
      direction="row"
      wrap="nowrap"
      sx={{ width: "100%", alignItems: "center" }}
    >
      <SortBySelect {...selectProps} />
      {onDelete && (
        <DeleteButton
          title="Delete"
          onClick={onDelete}
          disabled={!canEdit || deleteDisabled}
          DeleteDialogProps={DeleteDialogProps}
          data-testid="delete-button"
        />
      )}
      {onImport && (
        <TooltipButton
          title="Import"
          onClick={onImport}
          disabled={!canEdit}
          data-testid="import-button"
        >
          <CloudUploadOutlined />
        </TooltipButton>
      )}
      {onAdd && (
        <TooltipButton
          title={customAddTooltip ?? "Add"}
          onClick={onAdd}
          disabled={!canEdit}
          data-testid="add-button"
        >
          <Add />
        </TooltipButton>
      )}
      {onRefresh && (
        <TooltipButton
          title="Refresh"
          onClick={onRefresh}
          data-testid="refresh-button"
        >
          <Refresh />
        </TooltipButton>
      )}
    </Grid>
  );
};

export default Controls;
